import {
  SAVE_SELECT_DATE,
  CLEAR_SELECT_DATE,
  REPLEACE_SELECT_DATE,
} from './actions';

const initialState = {
  dates: [],
};

export default function selectDateReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_SELECT_DATE:
      return Object.assign({}, state, { dates: [...state.dates, action.data] });
    case CLEAR_SELECT_DATE:
      return Object.assign({}, state, { dates: [] });
    case REPLEACE_SELECT_DATE:
      const arr = [...state.dates];
      arr.splice(action.num, 1, action.data);
      return Object.assign({}, state, { dates: arr });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/routes/selectDate/modules/selectDate.js